import * as React from 'react'

const AssistanceDefaultIcon = (props: { className?: string }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Billing activity' clipPath='url(#clip0)'>
          <path
            id='Vector'
            d='M23 5.5V20C23 22.2 21.1182 24 18.8182 24H11.1864C10.0573 24 8.99091 23.57 8.20682 22.81L0 14.83C0 14.83 1.31727 13.6 1.35909 13.58C1.58909 13.39 1.87136 13.29 2.185 13.29C2.415 13.29 2.62409 13.35 2.81227 13.45C2.85409 13.46 7.31818 15.91 7.31818 15.91V4C7.31818 3.17 8.01864 2.5 8.88636 2.5C9.75409 2.5 10.4545 3.17 10.4545 4V11H11.5V1.5C11.5 0.67 12.2005 0 13.0682 0C13.9359 0 14.6364 0.67 14.6364 1.5V11H15.6818V2.5C15.6818 1.67 16.3823 1 17.25 1C18.1177 1 18.8182 1.67 18.8182 2.5V11H19.8636V5.5C19.8636 4.67 20.5641 4 21.4318 4C22.2995 4 23 4.67 23 5.5Z'
            transform='translate(23) scale(-1 1)'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AssistanceDefaultIcon



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Assistance.tsx